import {
  Stack,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconDocument } from "../../../../images/iconFile.svg";
import { ReactComponent as IconDiamond } from "../../../../images/icon-diamond.svg";
import { FieldTextarea } from "../../../../components/Fields";

import "../../../PrimeiraConsulta/modulos/styles.css";
import AccordionSummaryTitle from "../../../PrimeiraConsulta/modulos/AccordionSummaryTitle";

const handleProgressForm = (data) => {
  const fieldHide = "*";
  const fields = [data.anamnese, data.sintomasEQueixas];

  if (fields.every((campo) => campo !== "")) {
    return "full";
  } else if (fields.some((campo) => campo !== "" && campo !== fieldHide)) {
    return "partial";
  } else {
    return "empty";
  }
};

export default function AvaliacaoProcedimentos({
  data,
  setData,
  onSubmit,
  expanded,
  handleChangePanel,
}) {
  const progressForm = handleProgressForm(data);
  function handleSetData(value, field) {
    setData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }

  return (
    <Accordion
      defaultExpanded={false}
      expanded={expanded === "avaliacaoProcedimentos"}
      onChange={handleChangePanel("avaliacaoProcedimentos")}
      className="AccordionContainer"
    >
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="avaliacaoProcedimentos-content"
        id="avaliacaoProcedimentos-header"
        className="AccordionSummaryContainer"
      >
        <AccordionSummaryTitle
          title="Avaliação/Reavaliação"
          icon={<IconDocument style={{ width: "24px" }} />}
          progressForm={progressForm}
        />
      </AccordionSummary>
      <AccordionDetails>
        <Stack
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#d3e3eb",
            color: "#1e729f",
            width: "100%",
            maxWidth: "410px",
            paddingRight: "8px",
            borderRadius: "4px",
            marginBottom: "20px",
          }}
        >
          <IconDiamond fill="#FC8518" />
          <Typography fontSize={"14px"}>
            Este marcador indica campos de preenchimento obrigatório.
          </Typography>
        </Stack>
        <Stack>
          <form autoComplete="off" onSubmit={onSubmit}>
            <FieldTextarea
              label="Anamnese"
              value={data.anamnese ?? ""}
              setValue={(value) => handleSetData(value, "anamnese")}
              placeholder="Descreva as queixas do paciente e suas observações sob o quadro"
              required
            />
            <FieldTextarea
              label="Sintomas e queixas"
              value={data.sintomasEQueixas ?? ""}
              setValue={(value) => handleSetData(value, "sintomasEQueixas")}
              placeholder="Descreva as queixas do paciente e suas observações sob o quadro"
              required
            />

            <Stack
              direction="row"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mt: 3,
              }}
            >
              <Button variant="outlined" className="buttonText cancel">
                Cancelar
              </Button>
              <Button
                variant="contained"
                type="submit"
                name="avaliacaoProcedimentos"
                className="buttonText submit"
              >
                Salvar
              </Button>
            </Stack>
          </form>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
